import React from "react";
import * as PropTypes from "prop-types";

/**
 * Return a string representing the price of a product.
 */
const ProductPrice = ({ product, quantity, priceOverride, hideDecimalIfWhole }) => {
  let result;

  if (product)
    result = (priceOverride === null ? product.price : priceOverride) * quantity || 0;
  else
    result = 0;

  if (hideDecimalIfWhole && result % 1 === 0)
    result = String(result);
  else
    result = result.toFixed(2);

  return result;
};

ProductPrice.propTypes = {
  hideDecimalIfWhole: PropTypes.bool,
  product: PropTypes.object,
  quantity: PropTypes.number,
  priceOverride: PropTypes.number
};

ProductPrice.defaultProps = {
  hideDecimalIfWhole: false,
  quantity: 1,
  priceOverride: null,
  product: { price: 0 }
};

export default ProductPrice;